import { numberLocale, t } from "@/localization";

// Mirrors evt.live's lib/donations/messages.cjs so the broadcaster guestbook
// labels donation messages the same way viewers see them.
export const isDonationMessage = (message) =>
  !!message &&
  (message.donation_amount != null ||
    String(message.id || "").startsWith("donation:"));

export const donationPresentation = (message) => {
  const name =
    !message?.donor_name || message.donor_name === "Anonymous donor"
      ? t("Anonymous")
      : message.donor_name;
  const value = Number(message?.donation_amount);
  if (!Number.isFinite(value) || value <= 0) {
    return { name, message: t("Made a donation") };
  }
  try {
    const amount = new Intl.NumberFormat(numberLocale(), {
      style: "currency",
      currency: message.donation_currency || "USD",
      minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(value);
    return { name, message: t("Donated {amount}", { amount }) };
  } catch (error) {
    return { name, message: t("Made a donation") };
  }
};
